/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;max-width:200px;padding:4px;border-radius:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;background-color:var(--be-background-alternative);box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.user[_ngcontent-%COMP%]{color:var(--be-accent-default)}.content[_ngcontent-%COMP%]{padding:0 5px}"];
export { styles as styles };
